import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-search\">\n  <path fill-rule=\"evenodd\" d=\"M8.75 1.67a7.08 7.08 0 104.38 12.64l3.78 3.78 1.18-1.18-3.78-3.78A7.08 7.08 0 008.75 1.66zM3.33 8.75a5.42 5.42 0 015.42-5.42 5.42 5.42 0 015.42 5.42 5.42 5.42 0 01-5.42 5.42 5.42 5.42 0 01-5.42-5.42z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol